import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combine + dedupe Tailwind classNames. Same recipe as shadcn/ui.
 *
 *   cn('px-2', condition && 'px-4', 'text-foreground')
 *     → 'text-foreground px-4'         // px-4 wins over px-2 because tw-merge knows
 */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
